import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import { Table } from 'react-bootstrap';

import { Web3StatusContext } from "../../contexts/Web3StatusContext";
import TransactionStatus from '../TransactionStatus'

const { AccountData, ContractData, ContractForm } = newContextComponents;

class GetChangeAddress extends React.Component {
  static contextType = Web3StatusContext;

  state = {
    address: '',
    stackId: -1,
    adminAddressDataKey: null,
  };

  componentDidMount() {
    const { drizzle } = this.props;
    const contract = drizzle.contracts.GAMEFORESTSale;

    var adminAddressDataKey;
    if(this.props.getterParameter !== undefined)
      adminAddressDataKey = contract.methods[this.props.getterName].cacheCall(this.props.getterParameter);
    else
      adminAddressDataKey = contract.methods[this.props.getterName].cacheCall();
    
    this.setState({ adminAddressDataKey: adminAddressDataKey });
  }

  mySubmitHandler = (event) => {
    event.preventDefault();
    if(this.context.activeAccount == null) {
      console.log('no active account to approve');
      return;
    }
    const { drizzle } = this.props;
    const { GAMEFOREST, GAMEFORESTSale } = drizzle.contracts;

    var value = this.state.address;
    if(this.props.wei) {
      value = this.context.web3.utils.toWei(value, "ether");
    }
    var stackId;
    if(this.props.setterParameter !== undefined)
      stackId = GAMEFORESTSale.methods[this.props.setterName].cacheSend
          (this.props.setterParameter, value);
    else
      stackId = GAMEFORESTSale.methods[this.props.setterName].cacheSend
          (value);
    this.setState({ stackId: stackId });
  }

  myAddressChangeHandler = (event) => {
    let { value } = event.target;
    const address = value;
    this.setState({address: address});
  }

  // destructure drizzle and drizzleState from props
  render() {
    var statusMsg = '';
    if (this.state.stackId >= 0) {
      statusMsg = (
        <TransactionStatus
          drizzle={this.props.drizzle}
          drizzleState={this.props.drizzleState}
          stackId={this.state.stackId}
        >

        </TransactionStatus>
      );
    }

    var disabled = this.context.activeAccount == null;

    var adminAddress = "";
    if(!disabled) {
      const { GAMEFORESTSale } = this.props.drizzleState.contracts;

      if(this.state.adminAddressDataKey != null) {
        var addressContract = GAMEFORESTSale[this.props.getterName][this.state.adminAddressDataKey];
        if(addressContract != undefined) {
          if(addressContract.value) {
            adminAddress = addressContract.value;
            if(this.props.wei) {
              adminAddress = this.context.web3.utils.fromWei(adminAddress, "ether");
            }
          }
        }
      }
    }

    var form = '';
    if(this.props.setterName !== undefined) {
      form = (
        <form onSubmit={this.mySubmitHandler}>
            {statusMsg}<br/>
            Address:{" "}
            <input
              value={this.state.address}
              onChange={this.myAddressChangeHandler}
            />
            <br/>
            <input
            type='submit'
            value="Submit"
            disabled={disabled}
            />
            <br/>
        </form>
      );
    }

    return (
      <div>
        {adminAddress}<br/>
        {form}
      </div>
    );
  }
};

export default GetChangeAddress;
